/**
 * DSLBadge
 *
 * Renders one or more DSL division badges stacked vertically in the
 * bottom-right corner of a card.
 * The parent div must be position:relative (all card layer divs are).
 *
 * type: 'mg' | 'animation' | 'comms' | 'interactive'
 *       or an array of the above for multiple badges
 */

const BADGE_SRCS = {
  mg:          '/icons/DSL-MG-Badge.svg',
  animation:   '/icons/DSL-Animation-Badge-Test.svg',
  comms:       '/icons/DSL-Comms-Badge.svg',
  interactive: '/icons/DSL-Interactive-Badge.svg',
}

export default function DSLBadge({ type }) {
  if (!type) return null
  const types = Array.isArray(type) ? type : [type]
  const srcs = types.map(t => BADGE_SRCS[t]).filter(Boolean)
  if (srcs.length === 0) return null
  return (
    <div className="dsl-badge-stack">
      {srcs.map((src, i) => (
        <img
          key={i}
          className="dsl-badge"
          src={src}
          alt={`DSL ${types[i]} badge`}
          draggable={false}
        />
      ))}
    </div>
  )
}
